import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { ProjectState } from "./state";

const defaultState: ProjectState = {
  projectList: [],
  project: {},
  myProjects: [],
  projectSceneList: [],
  projectUserList: [],
  reportStat: {
    count: 1,
    next: "",
    previous: "",
    results: [
      {
        id: 0,
        project_name: "", //项目名称
        project_id: 0,
        report_auto: 0, //自动发送报告数
        report_manual: 0, //手动发送报告数
        update_time: "", //最近发送时间，后台已处理为可读字符串
      },
    ],
  },
  visitStatistics: {
    count: 1,
    next: "",
    previous: "",
    results: [
      {
        id: 1,
        user_name: "user1",
        user_ip: "",
        visit_time: "2021-10-08 22:33:22",
        visit_date: "2021-10-08",
        page_url: "http://localhost:8081/device-management",
        module: "设备管理",
        dept: "",
      },
    ],
  },
  visitStatTrend: {
    date_list: [], // 横坐标
    platform_page_views: [], // 平台页面浏览量
    platform_user_visits: [],
  },
  createScript: {
    original_scene_id: 1,
    chinese: "1",
    project: 1,
  },
  createTopScript:{
    project_name:'',
  
  project: 0,
  team:'',
  game_type:'',
  data_type:'',
  project_key:''
  },
  projectScenePage: {
    count: 0,
    next: "",
    previous: "",
    results: [],
  },
  projectSgameSkinList:{},
  monitorTrend: {},
  monitorlist: {},
  top_project_scenes:[],
  monitorUploadTrend: {},
  monitorUploadList: {},
  topPerformance:{},
  topPerformanceList:{},
  topPerformanceListtAdvance:{},
  topPerformanceOld:{},
  topProjectPerformance:[],
  topOptions:{},
  topLabelPerformance:[],
  topMainLabelPerformance:[],
  topModelPerformance:[],
  topLevelPerformance:[],
  topTesterPerformance:[],
  topCpuList:{},
  topProjectLis:[],
  topProblemSummary:{},
  topProblemByCpu:{},
  topSceneList:{},
  topSceneListVersion:{},
  topModelList:{},
  topModelListVersion:{},
  topVersionList:{},
  topProjectType:{},
  topVersionData:{},
  topVersionListVersion:{},
  topVersionListProblem:{},
  testAppointment:[],
  GamesDate:[],
  hokIcon:{},
  hokIn:{},
  hok_skin_versions:{},
  hok_skin_devices:[],
  hok_skin_data:{},
  hok_skin_data_page:[],
  HokInV1:{},
  hokIn_add:[],
  hokIn_add_v1:[],
  hokOut_add:[],
  hokOut_add_v1:[],
  hokOut:{},
  hokOutV1:{},
  hokDeviceList:{},
  hokDeviceOutList:{},
  modelList:{},
  modelOptions:[],
  hokInSkinTrend:{},
  hokOutSkinTrend:{},
  GamesData:{},
  testAppointmentAdamins:[],
  testAppointmentTable:{},
  testAppointmentTableAll:{},
};

export const projectModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
